<template>
    <section class="section-padding" id="curriculum">
        <div class="container-fluid container-lg">
            <div class="row justify-content-center align-items-center">
                <div class="col-12 text-center section-header">
                    <h2 class="mb-2">Curriculum</h2>
                    <p>Essential layouts and concepts of programming languages we teach</p>
                </div>
            </div>

            <div class="row justify-content-center align-items-center g-5 mt-3 mt-lg-4 px-md-5 px-lg-0" v-match-heights="{
    el: ['.service-box h3', '.service-box p'],  // Array of selectors to fix
  }">
                <div v-for="(service, index) in services" :key="index" class="col-11 col-md-6 col-lg-4">
                    <div class="service-box px-3 py-4 bg-white shadow-sm rounded">
                        <div class="service-box-icon mb-4">
                            <i :class="service.icon"></i>
                        </div>
                        <h3 class="mb-3">{{ service.title }}</h3>
                        <p v-html="service.description"></p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data(){
        return {
            services: [{
                icon: "fa fa-laptop-code",
                title: "Frontend Development",
                description: "Learn to build a stunning User Interface from scratch using <b>HTML</b>, <b>CSS</b>, <b>Bootstrap</b>, <b>Javascript</b>, <b>ReactJs</b> and <b>VueJS</b>"
            },
            {
                icon: "fa fa-palette",
                title: "UI/UX Design",
                description: "Learn to use <b>FIGMA</b>(a fully featured UI/UX design platform) professionally to design a stunning User Interface",
            },
            {
                icon: "fa fa-laptop-code",
                title: "Backend(Javascript)",
                description: "Learn to use <b>NodeJS</b>, <b>ExpressJS</b>, <b>MongoDB</b>, <b>Redis</b> to build a rich and secure WEB API(Application Programming Interface)",
            },
            {
                icon: "fa fa-laptop-code",
                title: "Backend(PHP)",
                description: "Learn to use <b>PHP</b>, <b>Laravel</b> , <b>MySQL</b> and <b>PostgresSQL</b> to build a rich and secure WEB API(Application Programming Interface)",
            },
            {
                icon: "fa fa-laptop-code",
                title: "Fullstack(Javascript)",
                description: "Learn to use <b>Frontend Stack</b> and <b>Backend Stack(Javascript)</b> to build a rich fullsatck web application",
            },
            {
                icon: "fa fa-laptop-code",
                title: "Fullstack(PHP)",
                description: "Learn to use <b>Frontend Stack</b> and <b>Backend Stack(PHP)</b> to build a rich fullsatck web application",
            },
            ]
        }
    }
}
</script>

<style>
    #curriculum h2 {
        font-size: 1.3rem;
        color: var(--dacode-primary-color);
    }

    #curriculum #service-box p {
        opacity: .8 !important;
    }
    #curriculum b {
        font-size: .9rem;
    }
</style>